export const ORG_SWITCHER_DROPDOWN_CONTENT_ID = 'org-switcher-dropdown-content';
export const ORG_SELECTOR_DROPDOWN_CONTENT_ID = 'org-selector-dropdown-content';
